import axios from "@/plugins/axios";

export default {
  getDocument(id) {
    return axios.get(`/booking_contracts/${id}`);
  },
  getDocumentList(booking_id) {
    return axios.get(`/bookings/${booking_id}/documents`);
  },

  addDocument(booking_id, { name, key }) {
    return axios.post(`/bookings/${booking_id}/documents`, { name, key });
  },
  updateDocument(id, { display_name, old_name, dependent_id }) {
    // Note: CANNOT replace actual document
    // Other specifics (eg. Name) only
    return axios.post(`/booking_contracts/${id}`, {
      display_name,
      old_name,
      booking_id: dependent_id,
    });
  },
  deleteDocument(id) {
    return axios.delete(`/booking_contracts/${id}`);
  },
  deleteDocumentList(idList) {
    return axios.delete("/booking_contracts", {
      data: { document_list: idList },
    });
  },
};
